import TodoContainer from "../../../Components/Applications/Todo/TodoContainer";

const Todo = () => {
  return <TodoContainer />;
};

export default Todo;
